import Button from '@/components/commons/Button'
import { AttentionRoundIcon } from '@/components/icons'
import { renderCustomApiMessage } from '@/utils/renderCustomApiMessage'

import {
  BuildCustomMessageAttentionCaseParams,
  CustomMessageAttentionCase,
} from './types'

export function buildCustomMessageAttentionCase({
  customMessage,
  keyPrefix = 'custom-message',
  onClose,
}: BuildCustomMessageAttentionCaseParams): CustomMessageAttentionCase {
  return {
    icon: <AttentionRoundIcon className="fill-status-red w-[80px] h-[80px]" />,
    title: <h5 className="prose-headline-h5 text-status-red">Atenção</h5>,
    paragraph: (
      <span className="flex w-full flex-col gap-4 items-start">
        {renderCustomApiMessage(customMessage, keyPrefix)}
      </span>
    ),
    buttons: (
      <Button
        className="w-[158px]"
        text="Voltar"
        type="button"
        onClick={onClose}
      />
    ),
  }
}
